import { cva } from "class-variance-authority"

export const tabsTriggerVariants = cva(
  "ui-tabs-trigger inline-flex gap-1 items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
  {
    variants: {
      size: {
        sm: "px-2 py-0.5",
        md: "px-3 py-1 ",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)
